import styled from 'styled-components';
const Main = styled.div`
    margin-top: 50px;
    background: whitesmoke;
    text-align: center;
`;
const MainClass = styled.div`
    margin-top: 50px;
    background: white;
    text-align: center;
`;
const Iframe = styled.iframe`
  width: 100%;
  height: 320px;
  margin: 30px auto;
`;

const Manseki = styled.span`
  color: red;
`;


const SvgTel = <svg class="h-6 w-6 text-orange-500 inline"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
</svg>

export default function Introduction() {
  return (
  <>
    <Main>
    <h3 className='pt-5 font-bold text-xl'>「体験会」のご案内</h3> 
      {/* <h3 className='mt-5 p-5 text-blue-400 text-2xl'><span className='text-black'>※３月の体験会は終了いたしました</span></h3> */}
      {/* <h3 className='mt-5 text-blue-400 text-2xl'><span className='text-black'>STEMON秦校:</span>&nbsp;3/10(日)</h3> */}
      <h3 className='mt-5 text-blue-400 text-2xl'><span className='text-black'>STEMON旭校:</span>&nbsp;4/21(日)</h3>
      <div className='mt-5'>
        <p className='mt-2'>内容：ブロック制作を通した物理レッスン</p>  
        <p className='mt-2'>：プログラミング入門</p>  
        {/* <p className='mt-2'>小１～小４・・10:30～11:30</p> */}
        {/* <p className='mt-2 mb-3'>新年長・・・・・・13:00～14:00</p> */}
        {/* <p className='mt-2 mb-3'>新小１～新小３・・<Manseki>午前の部（小学生対象）は定員に達したため、締め切りました。</Manseki></p> */}
        <p className='mt-2 mb-3'>小１～小３・・10:30～11:30</p>
        {/* <p className='mt-2 mb-2'>&lt;秦校&gt;&nbsp;小１～小３・・10:30～11:30、年中・年長・・13:00～14:00</p> */}
        <p className='mt-2 mb-3'>年中～年長・・13:00～14:00</p>
        <p className='mt-2 mb-3'>※小１～小３・・10:30～11:30の枠は残り<span style={{color: 'red'}}>１組</span>となります。</p>
        <p className='mt-2 mb-3'>※小学４年生以上はお問い合わせください。</p>
        
        { <button className='mb-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'>
          <a href="https://docs.google.com/forms/d/1tWr4DBvRhhpGevOzgHN68-jNYtsrLemaX9Mjigu4KWk/viewform?edit_requested=true">
          体験会の申し込みはこちら
          </a> 
        </button> }

      </div>
    </Main>
    <MainClass>
      <div className='mt-3 grid grid-cols-3  md:grid-cols-6 gap-4'>
        <div className='col-span-3 rounded border-solid border p-5'>
          <p className='font-bold text-3xl'>STEMONイオン高知旭町校</p>
          <div><Iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d988.4989104757709!2d133.5049928543817!3d33.55595464303343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354e18f29a9a02bb%3A0x5621c0793836db59!2z44Kk44Kq44Oz6auY55-l5pet55S65bqX!5e0!3m2!1sja!2sjp!4v1646988993749!5m2!1sja!2sjp" loading="lazy"></Iframe></div>
          <p className='font-bold'>高知県高知市旭町3丁目94</p>
          <p className='font-bold'>{SvgTel}&ensp;088-802-5651</p>
        </div>
        <div className='col-span-3 rounded border-solid border p-5'>
          <p className='font-bold text-3xl'>STEMON秦校</p>
          <div><Iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1397.612801265094!2d133.53316088224463!3d33.57669630042055!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe88c9bd963cde09f!2z44K544OG44Oi44Oz56em5qCh!5e0!3m2!1sja!2sjp!4v1646983051220!5m2!1sja!2sjp"  loading="lazy"></Iframe></div>
          <p className='font-bold'>高知市西秦泉寺73-1ソワール西秦I</p>
          <p className='font-bold'>{SvgTel}&ensp; 088-802-8739</p>
        </div>
      </div>
    </MainClass>
  </>
  );
}